import { createContext } from "react";

const MemeContext = createContext();

export default MemeContext;
